import React, { ComponentProps } from 'react';
import { CheckmarkFilled as CarbonCheckmarkFilled } from '@carbon/react/icons';
import { iconPropTypes, iconDefaultProps } from '../../types/prop-types/icons';

export type TableRowProps = ComponentProps<typeof CarbonCheckmarkFilled>;

const getCheckmarkFilled = (size = 16) => {
  const CheckmarkFilled = (props: TableRowProps) => (
    <CarbonCheckmarkFilled size={size} {...props} />
  );

  CheckmarkFilled.propTypes = iconPropTypes;
  CheckmarkFilled.defaultProps = iconDefaultProps;

  return CheckmarkFilled;
};

export const CheckmarkFilled16 = getCheckmarkFilled();
export const CheckmarkFilled20 = getCheckmarkFilled(20);
